import { apiRequest, handleCall } from 'syft-acp-core/api/call'

import type { FetchEmployerVenueNameAction, SearchEmployerVenuesAction } from './actions'
import type { FetchEmployerVenueNamePayload, SearchEmployerVenuesPayload } from './types'

export const VENUE_SEARCH_PAGE_SIZE = 100

/**
 * GET /api/v2/admin/employers/:id/venues. Admin-only, paginated, id and name only, and
 * `query` matches a venue ID exactly or the name as a substring. Large employers have
 * thousands of venues (OCS ~8,000), so callers search this rather than downloading the
 * full `venues_for_filters` list. `exclude_deleted` is opt-in because other callers of
 * this endpoint rely on soft-deleted venues being listed.
 */
const listAdminEmployerVenues = (
  employerID: number,
  query: string,
  payload: SearchEmployerVenuesPayload | FetchEmployerVenueNamePayload,
) =>
  new Promise((resolve, reject) => {
    handleCall(
      apiRequest({
        path: `/admin/employers/${employerID}/venues`,
        reqArgs: {
          ...(query ? { query } : {}),
          per_page: VENUE_SEARCH_PAGE_SIZE,
          exclude_deleted: true,
        },
      }),
      resolve,
      reject,
      true,
      payload,
    )
  })

export const searchEmployerVenues = ({ payload }: SearchEmployerVenuesAction) =>
  listAdminEmployerVenues(payload.employerID, payload.query, payload)

export const fetchEmployerVenueName = ({ payload }: FetchEmployerVenueNameAction) =>
  listAdminEmployerVenues(payload.employerID, payload.venueID, payload)
